import { Component, Input, OnInit, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { RealTimeCaptionsService } from 'go-modules/captions/real-time-captions.service';
import { STATES } from 'go-modules/media-player';
import { TranslateService } from '@ngx-translate/core';
import { RealtimeTranscript } from 'assemblyai';
import { NgxFeatureFlagService } from '../../services/feature-flag/feature-flag.service';
@Component({
	selector: 'real-time-captions',
	templateUrl: './real-time-captions.component.html',
	styleUrls: ['./real-time-captions.component.scss'],
	standalone: false
})

export class RealTimeCaptionsComponent implements OnInit, OnChanges, OnDestroy {
	@Input() public audioStream: MediaStream;
	@Input() public playerState: STATES;
	@Input() public mediaId: number;

	public captionString = '';
	private finalizedCaptionText = '';

	constructor (
		private translate: TranslateService,
		private featureFlag: NgxFeatureFlagService,
		private captionService: RealTimeCaptionsService
	) {}

	public ngOnInit (): void {
		this.captionService.init(this.featureFlag.isAvailable('HEYGEN'));
		this.captionService.on('data', this.onCaptionData);
		this.captionService.on('error', this.onCaptionError);
	}

	public ngOnChanges (changes: SimpleChanges): void {
		if ('playerState' in changes) {
			switch (this.playerState) {
				case STATES.BUFFERING:
				case STATES.PAUSED:
					this.captionService.setPaused(true);
					break;
				case STATES.PLAYING:
					this.captionService.setPaused(false);
					break;
				case STATES.COMPLETE:
					this.captionService.stop();
					this.finalizedCaptionText = '';
					this.captionString = '';
					break;
			}
		}

		if ('audioStream' in changes) {
			if (!this.playerState) {
				this.captionService.setPaused(false);
			}

			if (this.audioStream) {
				this.captionService.startTranscribingStream(this.audioStream, this.mediaId);
			} else {
				this.captionService.stopTranscribingStream();
				this.finalizedCaptionText = '';
				this.captionString = '';
			}
		}
	}

	public ngOnDestroy (): void {
		this.captionService.off('data', this.onCaptionData);
		this.captionService.off('error', this.onCaptionError);
		this.captionService.destroy();
	}

	private onCaptionData = (data: RealtimeTranscript | any): void => {
		if ('text' in data) {
			const transcript = data.text || '';
			this.captionString = `${this.finalizedCaptionText} ${transcript}`;

			if (data.message_type === 'FinalTranscript') {
				this.finalizedCaptionText += ` ${data.text}`;
			}
		} else {
			const alt = data.results?.[0]?.alternatives?.[0];
			const transcript = alt?.transcript || '';
			this.captionString = `${this.finalizedCaptionText}${transcript}`;

			if (data.results?.[0]?.final) {
				this.finalizedCaptionText += transcript;
			}
		}
	};

	private onCaptionError = (error: Error): void => {
		if (error.message.includes('No speech detected for')) {
			this.captionString = this.translate.instant(
				'real-time-caption_error-captions-disabled-due-to-inactivity'
			);
		} else {
			this.captionString = this.translate.instant(
				'real-time-caption_error-service-cannot-connect'
			);
		}
	};
}
